import React from "react";

/**
 * TierUpgradeCard — "A referrer just reached Gold status"
 *
 * Triggered when a referrer crosses a tier threshold (3, 5, or 10 placements).
 * Shows the referrer's display name, new tier badge, and placement count.
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     display_name, new_tier, placement_count
 */
const TierUpgradeCard = ({ card }) => {
  const meta = card.metadata || {};
  const tier = meta.new_tier || "bronze";

  const tierStyles = {
    bronze:   { bg: "#f5e6d3", color: "#8b4513", label: "BRONZE" },
    silver:   { bg: "#e8e8e8", color: "#555",    label: "SILVER" },
    gold:     { bg: "#fef3c7", color: "#a16207", label: "GOLD" },
    platinum: { bg: "#e0f2fe", color: "#0369a1", label: "PLATINUM" },
  };

  const ts = tierStyles[tier] || tierStyles.bronze;

  return (
    <div style={styles.card}>
      <div style={styles.row}>
        <div style={styles.iconWrap}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a16207" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </div>

        <div style={styles.content}>
          <p style={styles.message}>
            <strong>{meta.display_name || "A referrer"}</strong> just reached{" "}
            <span style={{ ...styles.tierBadge, backgroundColor: ts.bg, color: ts.color }}>
              {ts.label}
            </span>{" "}
            status with {meta.placement_count || 0} successful placements!
          </p>
          <span style={styles.timestamp}>{formatTime(card.created_at)}</span>
        </div>
      </div>
    </div>
  );
};

function formatTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffHrs = (now - date) / (1000 * 60 * 60);
  if (diffHrs < 1) return "Just now";
  if (diffHrs < 24) return `${Math.floor(diffHrs)}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays === 1) return "1d ago";
  return `${diffDays}d ago`;
}

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "18px 20px",
  },
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  iconWrap: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    backgroundColor: "#fef3c7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  message: {
    fontSize: "15px",
    color: "#0f172a",
    margin: "0 0 6px 0",
    lineHeight: 1.4,
  },
  tierBadge: {
    fontSize: "11px",
    fontWeight: "700",
    padding: "2px 8px",
    borderRadius: "4px",
    letterSpacing: "0.3px",
  },
  timestamp: {
    fontSize: "12px",
    color: "#94a3b8",
  },
};

export default TierUpgradeCard;
